import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, phone });
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email and cell number and we'll send you a reset link"
      footer={<Link to="/login" className="text-emerald-400 hover:underline">Back to log in</Link>}
    >
      {sent ? (
        <div className="text-center space-y-3" data-testid="forgot-sent">
          <CheckCircle2 className="h-10 w-10 text-emerald-400 mx-auto" />
          <p className="text-sm text-slate-300">If that account exists, a reset link is on its way to your email and phone.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label>Email</Label>
            <Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-slate-950 border-slate-700 h-11" />
          </div>
          <div className="space-y-1.5">
            <Label>Cell phone number</Label>
            <Input data-testid="forgot-phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required placeholder="e.g. +1 (555) 123-4567" className="bg-slate-950 border-slate-700 h-11" />
          </div>
          {error && <p className="text-sm text-rose-400">{error}</p>}
          <Button data-testid="forgot-submit" type="submit" disabled={loading} className="w-full h-11 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
